import { CommunityProfileFragment, useCommunityProfileQuery } from 'shared/graphql';

type Options = Parameters<typeof useCommunityProfileQuery>[0];

/**
 * Hook for fetching community profile.
 * @ticket https://github.com/jebelapp/jebel/issues/1725
 */
export function useCommunityProfile(options: Options) {
  const { data: response, loading } = useCommunityProfileQuery(options);

  const community: CommunityProfileFragment | undefined = response?.community ?? undefined;

  return {
    data: community,
    loading,
  };
}
